import { assets } from "@core/assets";
import { Header, SideBar } from "@core/components";
import ProfileSettings from "@core/components/ProfileMenu";
import type { SideBarItem } from "@core/components";
import { useSidebarContext } from "@core/context";
import { cn } from "@core/utils";
import { Outlet } from "react-router-dom";

const SalesManagerLayout = () => {
  const { collapsed } = useSidebarContext();
  const salesSideBarItems: SideBarItem[] = [
    {
      title: "general",
      link: [
        {
          name: "workspaces",
          link: `/sales-manager`,
          icon: assets["layers-2"],
          type: "link",
        },
      ],
    },
  ];

  return (
    <div className="hidden md:block min-h-screen w-full">
      {/* Sidebar (fixed inside component) */}
      <SideBar
        backHome={false}
        items={salesSideBarItems}
        workspaceHeaderTitle="Sales Manager"
        className="md:w-[13rem] lg:w-[15rem]"
      />

      {/* Main */}
      <div
        className={cn(
          "min-w-0 transition-[margin] duration-200 ease-in-out",
          collapsed ? "ml-[4.3125rem]" : "md:ml-[13rem] lg:ml-[15rem]",
        )}
      >
        {/* Header */}
        <Header>
          <ProfileSettings />
        </Header>

        {/* Content */}
        <main className="mx-auto w-full max-w-[2000px] px-5 2xl:px-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SalesManagerLayout;
